import { immerable } from "immer";
import { OrderERPCreationMode } from "./order-erp-creation-mode";

export class ERPWorkOrderTriggerInfos {
  [immerable] = true;
  erpWorkOrderCreationMode: OrderERPCreationMode | null = null;
  erpWorkOrderWorkflowStepNameCreationTrigger: string | null = null;
  erpWorkOrderCompleteTaskOnCompletedWorkflow: boolean = false;

  constructor(init?: Partial<ERPWorkOrderTriggerInfos>) {
    Object.assign(this, init);
  }
}
